export default "/images/Pro-1a.png?2c9531bfc8902feb1445f9a6de4faad5";